<template>
  <div class="trends_container">
    <js-banner
      title="信息动态"
    />
    <div class="trends_wrapper">
      <js-group
        zh="信息动态"
        en="News"
        :list="group"
        style="flex-shrink: 0;"
      />
      <router-view class="content_container"/>
    </div>
  </div>
</template>

<script>
import JsBanner from '@/packages/JsBanner'
import JsGroup from '@/packages/JsGroup'
export default {
  name: 'trends',
  components: {
    JsBanner,
    JsGroup
  },
  data () {
    return {
      group: [{
        id: Math.random().toString(),
        label: '行业动态',
        path: '/trends/industry'
      }, {
        id: Math.random().toString(),
        label: '企业动态',
        path: '/trends/company'
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
.trends_wrapper {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  padding: 15px 0;
  .content_container {
    flex-shrink: 1;
    flex-grow: 1;
    margin-left: 30px;
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }
}
</style>
